import {
  CONVERSATIONS_STORE,
  getDb,
  promisifyRequest,
  promisifyTxn,
} from "./PdfDb";
import type { ConversationRecord } from "./types";

export async function getConversation(
  id: string,
): Promise<ConversationRecord | null> {
  try {
    const db = await getDb();
    const txn = db.transaction(CONVERSATIONS_STORE, "readonly");
    const row = await promisifyRequest(
      txn.objectStore(CONVERSATIONS_STORE).get(id),
    );
    return (row as ConversationRecord | undefined) ?? null;
  } catch {
    return null;
  }
}

export async function putConversation(
  id: string,
  chatId: string,
  messages: unknown[],
  engine?: ConversationRecord["engine"],
  agentSettings?: ConversationRecord["agentSettings"],
): Promise<void> {
  try {
    const db = await getDb();
    const txn = db.transaction(CONVERSATIONS_STORE, "readwrite");
    txn.objectStore(CONVERSATIONS_STORE).put({
      id,
      chatId,
      messages,
      ...(engine && { engine }),
      ...(agentSettings && { agentSettings }),
      updatedAt: Date.now(),
    } satisfies ConversationRecord);
    await promisifyTxn(txn);
  } catch {
    // IDB unavailable / quota exceeded — chat still works in memory.
  }
}

export async function deleteConversation(id: string): Promise<void> {
  try {
    const db = await getDb();
    const txn = db.transaction(CONVERSATIONS_STORE, "readwrite");
    txn.objectStore(CONVERSATIONS_STORE).delete(id);
    await promisifyTxn(txn);
  } catch {}
}
